import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const setupHeader = () => {
  if (route.meta.title) {
    document.title = `${route.meta.title} | スポットライト`;
  } else {
    document.title = 'スポットライト | 得意な工程で参加できるWEBTOONとマンガの投稿サイト';
  }
  if (route.meta && route.meta.description) {
    document.querySelector('meta[name=description]')?.setAttribute('content', route.meta.description as string);
  }
};
onMounted(() => {
  setupHeader();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})